import { ActionReducer, createFeature, createReducer, on } from '@ngrx/store';
import { SCORECARD_QUESTION_ACTIONS, SCORECARD_QUESTION_API_ACTIONS } from './scorecard-question-performance.actions';
import { IReportState } from '../../../../../shared/components/report-page/report-page.component';
import { ScorecardResult } from '../../../../../../graphql';

export const SCORECARD_QUESTIONS_STATE_KEY = 'scorecard-question-performance';

export interface IScorecardQuestionsState extends IReportState<ScorecardResult[]> {}

export const scorecardQuestionsState: IScorecardQuestionsState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  activeViewLabel: null,
};

const reducer: ActionReducer<IScorecardQuestionsState> = createReducer<IScorecardQuestionsState>(
  scorecardQuestionsState,
  on(SCORECARD_QUESTION_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SCORECARD_QUESTION_API_ACTIONS.success, (state, { rows, totalCount }) => ({
    ...state,
    loading: false,
    data: rows,
    totalCount,
  })),
  on(SCORECARD_QUESTION_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    totalCount: 0,
    error,
  })),
  on(SCORECARD_QUESTION_ACTIONS.setActiveView, (state, { viewName }) => ({
    ...state,
    activeViewLabel: viewName,
  })),
);

export const SCORECARD_QUESTIONS_REDUCER = createFeature({
  name: SCORECARD_QUESTIONS_STATE_KEY,
  reducer,
});
